export default __webpack_public_path__ + "static/ASLA_AptosBollard_1-a811f2b51eca4af1aa7dcbcfbbba657a.png";